import React from 'react';
import PropTypes from 'prop-types';
import Filter from 'common/components/responsive/filter';
import { getContentSortingOptions } from 'common/designer-modules/siteDesigner';

const ContentSorting = ({
   isMobile,
   onFilterChange,
   activeValue,
   contentType,
   contentCardSettings,
}) => {
   const allSorts = getContentSortingOptions(contentType, contentCardSettings);
   const activeState = allSorts.find(el => el.value === activeValue);

   return (
      <Filter
         name={ activeState.name }
         type='sort'
         data={ allSorts }
         desktopType={ isMobile ? 'mobile' : 'descktop' }
         className='border rounded-lg'
         onFilterChange={ (value, name) => {
            onFilterChange(value)
         } }
         onClickShowResult={ () => {} }
         activeSelectedValue={ {
            name: '',
            value: activeState.value,
         } }
         height='10'
         contentStyles={ {
            top: '44px',
         } }
         filterClassName='!flex-none'
         hasCloseButton
         hasClearButton={ false }
         showCloseButton
      />
   )
};

ContentSorting.propTypes = {
   isMobile: PropTypes.bool,
   onFilterChange: PropTypes.func,
   activeValue: PropTypes.string,
   contentCardSettings: PropTypes.object,
   contentType: PropTypes.string,
};

export default ContentSorting;
